/**
 * Hides all ad slot wrappers on the page. The caller decides when to use it (see `useHideAds` in the module file).
 */
export const hideAds = (): void => {
  const style = document.createElement('style');
  style.textContent = '.ad-slot{display:none!important}';
  document.head.appendChild(style);
};
